import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  users: [],
  user: null,
  userPaginate: {
    current_page: null,
    last_page: null,
    rowsPerPage: null,
    total: null
  }
}

// mutations
export const mutations = {
  [types.SET_USERS] (state, payload) {
    state.users = payload.data
    state.userPaginate.current_page = payload.current_page
    state.userPaginate.last_page = payload.last_page
    state.userPaginate.rowsPerPage = parseInt(payload.per_page)
    state.userPaginate.total = payload.total
  },
  [types.SET_USER] (state, user) {
    state.user = user
  }
}

// actions
export const actions = {
  async fetchUsers ({ commit }, payload) {
    try {
      const { data } = await axios.get(`/api/users`, {
        params: payload || ''
      })
      commit(types.SET_USERS, data)
    } catch (e) {
      console.log(e)
    }
  },

  async fetchInvitationUsers ({ commit }, payload) {
    try {
      const { data } = await axios.get(`/api/invitations`, {
        params: payload || ''
      })
      commit(types.SET_USERS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async deleteUsers (context, userIds) {
    try {
      await axios.post(`/api/users/delete`, { 'ids': userIds })
      context.dispatch('fetchInvitationUsers')
    } catch (e) { }
  },
  //   async fetchUser ({ commit }, id) {
  //     try {
  //       const { data } = await axios.get(`/api/users/${id}`)
  //       commit(types.SET_USER, data)
  //     } catch (e) {
  //       console.log(e)
  //     }
  //   },
  async createUser (context, user) {
    try {
      await axios.post('/api/users', user)
      context.dispatch('fetchUsers')
    } catch (e) {
      console.log(e)
    }
  },

  /* async updateUser (context, user) {
    try {
      await axios.put(`/api/users/${user.id}`, user)
      context.dispatch('fetchUsers')
    } catch (e) { }
  },*/
  async updateUserRole (context, user) {
    try {
      await axios.post(`/api/users/edit-role`, user)
      context.dispatch('fetchUsers')
    } catch (e) { }
  },

  async deleteUser (context, userId) {
    try {
      await axios.delete(`/api/users/${userId}`)
      context.dispatch('fetchUsers')
    } catch (e) { }
  }
}

// getters
export const getters = {
  users: state => state.users,
  user: state => state.user,
  userPaginate: state => state.userPaginate
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/user.js